module.exports = __webpack_public_path__ + "img/logo_footer_black.fbf842a9.svg";